import type { SYSFormField } from "../../../forms/fieldapi"
import { RangeFilterType } from "../../table"

export type _HeaderMenuFilter_Type = {
  HeaderMenuRangeFilterType?: RangeFilterType
  HeaderMenuRangeFilterValue?: any
  HeaderMenuRangeFilterValue2?: any
  HeaderMenuSelectPersistedFilterSort?: string
}

export let _HeaderMenuFilterFields: {
  [key in keyof _HeaderMenuFilter_Type]: SYSFormField
} = {
  HeaderMenuRangeFilterType: {
    type: "text",
    value: "none",
    list: {
      displayField: "Desc",
      valueField: "Val",
      mode: "Option",
      acceptOnlyListValues: false,
    },
    ui: {
      option: { inline: true },
      noLabel: true,
    },
  },
  HeaderMenuRangeFilterValue: {},
  HeaderMenuRangeFilterValue2: {},

  HeaderMenuSelectPersistedFilterSort: {
    type: "text",
    value: "",
    list: {
      displayField: "Desc",
      valueField: "Val",
      mode: "Select",
      selectOnly: true,
    },
    ui: { noLabel: true },
  },
}
